import { Button, ButtonProps } from '@mui/material';
import cn from 'classnames';
import { FC } from 'react';
import { RequestStatus } from 'src/shared/api/types';
import { Preloader } from 'src/shared/ui/_loaders/Preloader';
import s from './ButtonRounded.module.scss';

interface Props extends ButtonProps {
	status?: RequestStatus;
}

export const ButtonRounded: FC<Props> = (props) => {
	const {
		status, //
		disabled,
		children,
		color = 'primary',
		variant = 'outlined',
		className,
		...buttonProps
	} = props;

	const renderLoader = () => {
		return status === RequestStatus.loading ? <Preloader size="small" /> : '';
	};

	const isDisabled = () => {
		if (status !== undefined) {
			return status === RequestStatus.loading || disabled;
		} else {
			return disabled;
		}
	};

	// * Render
	return (
		<Button
			{...buttonProps}
			className={cn(s.container, className)}
			disabled={isDisabled()}
			color={color}
			variant={variant}
		>
			<span className={s.inner}>
				{children}
				{renderLoader()}
			</span>
		</Button>
	);
};
